import {useState} from "react";

function FaqList({index, question, answer}) {
    const [toggle, setToggle] = useState(false);

    return (
        <>
            <ul key={index}>
                <li className="mb-16 activePage border border-gray-100 rounded-4 p-4 ps-16 hover-border-main-600 hover-text-main-600">
                    <button
                        onClick={() => setToggle(!toggle)}
                        className="d-flex justify-content-between align-items-center gap-8 text-gray-700 w-100">
            <span>
              Q.{index + 1}) {question}
            </span>
                        <span
                            onClick={() => setToggle(!toggle)}
                            className="w-40 h-40 flex-center rounded-4 bg-main-50 text-main-600">
              <i
                  className={`${
                      toggle ? "ph ph-arrow-down" : "ph ph-arrow-right"
                  }`}></i>
            </span>
                    </button>
                    {toggle && (
                        <div>
                            <hr className="mt-1"/>
                            <p className="mt-1">Ans. {answer}</p>
                        </div>
                    )}
                </li>
            </ul>
        </>
    );
}

export default FaqList;
